// Login Page
export const MIXPANEL_USER_SESSION = {
  USER_LOGIN: "user_login",
  USER_LOGOUT: "user_logout",
};

// Home Page
export const MIXPANEL_HOME_PAGE = {
  SHORTCUT_RUN_REPORT: "shortcut_run_report",
  SHORTCUT_ADD_PRODUCT: "shortcut_add_product",
  SHORTCUT_ADD_VIDEOS: "shortcut_add_videos",
  SHORTCUT_ADD_VIDEOS_SUCCESS: "shortcut_add_videos_success",
  RECENT_TRENDING_TOGGLE_VIDEOS_TAB: "recent_trending_toggle_videos_tab",
  RECENT_TRENDING_TOGGLE_CREATORS_TAB: "recent_trending_toggle_creators_tab",
  RECENT_TRENDING_VIEW_ALL_VIDEOS: "recent_trending_view_all_videos",
  RECENT_TRENDING_VIEW_ALL_CREATORS: "recent_trending_view_all_creators",
  BRAND_OVERVEW_VIEW_BRAND_ENGAGEMENT_REPORT:
    "brand_overview_view_brand_engagement_report",
  BRAND_OVERVIEW_VIEW_SENTIMENT_REPORT: "brand_overview_view_sentiment_report",
  BRAND_OVERVIEW_VIEW_TOP_PRODUCTS_REPORT:
    "brand_overview_view_products_report",
  BRAND_OVERVIEW_VIEW_DEMOGRAPHICS_REPORT:
    "brand_overview_view_demographics_report",
  WORD_CLOUD_VIEW_DETAILS: "word_cloud_view_details",
};

// Product Page
export const MIXPANEL_PRODUCTS_PAGE = {
  MY_PRODUCTS_TAB: "my_products_tab_product_page",
  COMPETITORS_TAB: "competitors_tab_product_page",
  CLEAR_ALL_FILTERS: "products_clear_filters",
  PRODUCT_CARD: "select_product",
  SELECT_FILTER_ITEM: "select_filter_item_product_page",
};

// Videos Page
export const MIXPANEL_VIDEOS_PAGE = {
  MY_VIDEOS_TAB: "videos_my_videos_tab",
  COMPETITORS_TAB: "videos_competitors_tab",
  CLEAR_ALL_FILTERS: "videos_clear_filters",
  SELECT_FILTER: "videos_select_filter",
  PUBLISH_TO_APP: "videos_publish_to_app",
  DOWNLOAD_ALL_TRANSCRIPTS: "videos_download_all_transcripts",
  CLICK_VIDEO_CARD: "videos_click_video_card",
};

// Video Details Page
export const MIXPANEL_VIDEO_DETAILS_PAGE = {
  PUBLISH_TO_APP: "video_detail_publish_to_app",
  UNPUBLISH_FROM_APP: "video_detail_unpublish_from_app",
  PEOPLE_IN_VIDEO_TAB: "video_detail_people_in_video_tab",
  TRANSCRIPT_TAB: "video_detail_transcript_tab",
  BRAND_SAFETY_TAB: "video_detail_brand_safety_tab",
  SUBMIT_FOR_RE_ANALYZE: "submit_for_re_analyze",
};

// Creators Page
export const MIXPANEL_CREATORS_PAGE = {
  MY_CREATORS_TAB: "my_creators_tab_creators_page",
  COMPETITORS_TAB: "competitors_tab_creators_page",
  VIEW_ALL_TAB: "view_all_tab_creators_page",
  CONTACT_CREATORS: "contact_creators",
  DOWNLOAD_CSV: "download_csv",
  CREATOR_CARD: "select_creator_card",
  SELECT_FILTER_ITEM: "select_filter_item",
  CLEAR_ALL_FILTERS: "creators_clear_filters",
};

// Reports Page
export const MIXPANEL_REPORTS_PAGE = {
  SELECT_CUSTOM_REPORT: "select_custom_report",
  SELECT_DEMOGRAPHIC_REPORT: "select_demographic_report",
  SELECT_SENTIMENT_REPORT: "select_sentiment_report",
  SELECT_ENGAGEMENT_REPORT: "select_engagement_report",
  SELECT_SPEECH_REPORT: "select_speech_report",
  SELECT_FILTER_ITEM: "select_filter_item_report",
};

// App Manager Page
export const MIXPANEL_APP_MANAGER_PAGE = {
  BRAND_TAB: "brand_tab_app_manager_page",
  SHOPPER_TAB: "shopper_tab_app_manager_page",
  VIEW_ALL_TAB: "view_all_tab_app_manager_page",
  VIDEO_CARD: "select_video",
  OPEN_UNPUBLISH_FROM_APP_MODAL: "open_unpublish_from_app_modal",
  UNPUBLISH_FROM_APP: "unpublish_from_app",
  SELECT_FILTER_ITEM: "select_filter_item_app_manager_page",
};

// Shared mixpanel events for Videos and Products Card (Heart, Flag, Edit Note, Edit)
export const MIXPANEL_PRODUCTS_VIDEOS_CARD = {
  ADD_TO_FAVORITES: "add_to_favorites",
  COPY_EMAIL: "copy_email",
  FLAG: "flag",
  OPEN_EDIT_NOTE_DIALOG: "open_edit_note_dialog",
  SUBMIT_EDIT_NOTE: "submit_edit_note",
  EDIT_PRODUCT: "edit_product",
};
